<template>
  <b-card-actions
    ref="cardAction"
    :title="stageTitle"
    :collapsed="collapsed"
    @refresh="refreshStop('cardAction')"
    @headClick="headerClick"
    @close="deactivateStage"
    @edit="editStage"
  >
    <b-button
      v-if="!GET_USER_PERMISSIONS.includes('super_manager')"
      v-b-modal.flat-modal
      variant="primary"
      class="w-100"
      @click="$emit('newFlatClick')"
    >
      <feather-icon icon="PlusIcon" />
      <p>
        {{ $t("objects.add_rooms") }}
      </p>
    </b-button>
    <b-row>
      <b-col cols="12">
        <b-table
          responsive
          :fields="fields"
          :items="items"
          bordered
        >
          <template #head()="data">
            <span>{{ $t(data.label) }}</span>
          </template>
          <template #empty>
            <div class="text-center">
              {{ $t("general.no_records_to_show") }}
            </div>
          </template>
          <template #cell(status)="props">
            <b-badge
              v-if="props.item.current_status"
              :variant="props.item.current_status.color || 'primary'"
            >
              <span v-if="props.item.current_status.title">
                {{
                  props.item.current_status.title[$i18n.locale] ||
                    $t("objects.freely")
                }}
              </span>
            </b-badge>
          </template>
          <template #cell(total_area)="props">
            {{ props.item.total_area.toFixed(2) }}
          </template>
          <template #cell(calculations)="props">
            <b-button
              variant="link"
              size="sm"
              @click="getCalculations(props.item.id)"
            >
              {{ $t("objects.views") }}
            </b-button>
          </template>
          <template #cell(total_price)="props">
            {{ $_moneyFormatter(props.item.total_price) }}
          </template>
          <template #cell(is_studio)="props">
            <b-form-checkbox
              :checked="props.item.is_studio"
              class="d-flex justify-content-center"
              name="check-button"
              switch
              disabled
            />
          </template>
          <template #cell(free_planning)="props">
            <b-form-checkbox
              class="d-flex justify-content-center"
              :checked="props.item.is_free_planning"
              name="check-button"
              switch
              disabled
            />
          </template>
          <template #cell(actions)="props">
            <div class="d-flex justify-content-around">
              <!-- <b-button
                variant="info"
                size="sm"
                class="mr-50"
              >
                <feather-icon icon="EyeIcon" />
              </b-button> -->
              <b-button
                v-if="!GET_USER_PERMISSIONS.includes('super_manager')"
                v-b-modal.flat-modal
                variant="warning"
                size="sm"
                class="mr-50"
                @click="$emit('editClick', props.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                v-if="!GET_USER_PERMISSIONS.includes('super_manager')"
                variant="danger"
                size="sm"
                @click="$emit('deleteClick', props.item.id)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card-actions>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import {
  BRow,
  BCol,
  BTable,
  BButton,
  BFormCheckbox,
  BBadge,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { mapGetters } from 'vuex'
import extra from '@/mixins/extra'

export default {
  components: {
    BCardActions,
    BRow,
    BCol,
    BTable,
    BButton,
    FeatherIcon,
    BFormCheckbox,
    BBadge,
  },
  mixins: [extra],
  props: {
    items: {
      type: Array,
      required: true,
    },
    stageTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      collapsed: true,
      showPrice: false,
      fields: [
        {
          label: 'objects.number_of_the_room',
          key: 'flat_number',
        },
        {
          label: 'objects.numbers_room',
          key: 'rooms_count',
        },
        {
          label: 'objects.area',
          key: 'total_area',
        },
        {
          label: 'objects.full_price',
          key: 'total_price',
          thClass: 'text-center',
        },
        {
          label: 'objects.status',
          key: 'status',
        },
        {
          label: 'objects.studio',
          key: 'is_studio',
          // tdClass: 'd-flex justify-content-center',
        },
        {
          label: 'objects.free_layout',
          key: 'free_planning',
        },
        {
          key: 'calculations',
          label: 'objects.costing',
        },
        {
          label: 'objects.actions',
          key: 'actions',
          tdClass: 'p-1',
        },
      ],
      // items: [
      //   {
      //     id: 1,
      //     flat_number: '1',
      //     rooms_count: '2',
      //     total_area: '75',
      //     total_price: '250000000',
      //     status: true,
      //     is_studio: false,
      //     free_planning: false,
      //   },
      //   {
      //     id: 2,
      //     flat_number: '1',
      //     rooms_count: '2',
      //     total_area: '75',
      //     total_price: '250000000',
      //     status: true,
      //     is_studio: false,
      //     free_planning: false,
      //   },
      // ],
    }
  },
  computed: {

    ...mapGetters('users', ['GET_USER_PERMISSIONS']),
  },
  methods: {
    refreshStop(cardName) {
      setTimeout(() => {
        this.$refs[cardName].showLoading = false
      }, 3000)
    },
    headerClick() {
      this.$refs.cardAction.triggerCollapse()
    },
    saveChanges(data) {
      console.log(data)
    },
    deactivateStage() {
      this.$emit('deactivateStage')
    },
    editStage() {
      this.$emit('editStage')
      // this.headerClick()
    },
    getCalculations(id) {
      this.$emit('getCalculations', id)
    },
  },
}
</script>

<style>
</style>
